import { WebsocketMessageContentType } from '../../types/ws-events';

/** Получает корректный messageContentType для ответа-клика по кнопке */
export const getResponseMessageContentType = (messageContentType: WebsocketMessageContentType) => {
  if (
    messageContentType === WebsocketMessageContentType.JsonCsatRequest ||
    messageContentType === WebsocketMessageContentType.JsonChatBotRequest
  ) {
    return {
      [WebsocketMessageContentType.JsonCsatRequest]: WebsocketMessageContentType.JsonCsatResponse,
      [WebsocketMessageContentType.JsonChatBotRequest]: WebsocketMessageContentType.JsonChatBotResponse,
    }[messageContentType];
  } else {
    return messageContentType;
  }
};
